import React from "react";
import { Card } from "@mui/material";
import { PageHeader } from "@outpave/ds";
import { Page } from "components/layout/reusableLayouts";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReferForm, { ReferFormValues } from "../components/common/ReferForm";

const Refer: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const state = location.state as ReferFormValues | undefined;

  const initialValues: ReferFormValues = {
    company: state?.company ?? "",
    email: state?.email ?? "",
    firstname: state?.firstname ?? "",
    lastname: state?.lastname ?? "",
    phone: state?.phone ?? "",
  };

  return (
    <Page>
      <PageHeader
        title={t("Refer a company")}
        subtitle={t("Refer your contacts to join the platform")}
      />
      <Card
        variant="outlined"
        sx={{
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          padding: "var(--space-5)",
        }}
      >
        <ReferForm initialValues={initialValues} />
      </Card>
    </Page>
  );
};

export default Refer;
